import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

//Componentes material
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
  MAT_DATE_LOCALE,
  MatNativeDateModule
} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HeaderComponent } from './header/header.component';
import { SafeHtmlPipe } from './safe-html.pipe';

// Controllers
import { DocumentDetailsComponent } from './documents/details/details.component';
import { DocumentsComponent } from './documents/documents/documents.component';
import { GuestDocumentsComponent } from './guest/documents/documents/documents.component';
import { GuestSetdownComponent } from './guest/documents/setdown/setdown.component';
import { GuestSetSignerComponent } from './guest/documents/setsigner/setsigner.component';
import { GuestSetupComponent } from './guest/documents/setup/setup.component';
import { GuestLoginComponent } from './guest/login/login.component';
import { LoginComponent } from './login/login.component';
import { ProcessesConfigComponent } from './processes/config/config.component';
import { ProcessComponent } from './processes/process/process.component';
import { SigndocumentprocessComponent } from './processes/signdocumentprocess/signdocumentprocess.component';
import { ViewProcessDocumentComponent } from './processes/viewdocument/viewdocument.component';
import { ViewprocessComponent } from './processes/viewprocess/viewprocess.component';
import { EditsignerComponent } from './signers/edit-signer/edit-signer.component';
import { NewsignerComponent } from './signers/new-signer/new-signer.component';
import { SignersComponent } from './signers/signers/signers.component';
import { ViewSignerComponent } from './signers/view-signer/view-signer.component';
import { StatsComponent } from './stats/stats.component';
import { SigntemplateComponent } from './templates/signtemplate/signtemplate.component';
import { TemplatesComponent } from './templates/templates/templates.component';
import { ViewtemplateComponent } from './templates/viewtemplate/viewtemplate.component';

// Shared
import { SharedDocumentDetailsComponent } from './shared/document/details/details.component';
import { SpinnerComponent } from './shared/spinner/spinner.component';
import { StopPropagationDirective } from './shared/stopPropagation.directive';

// Adapters
import { DateAdapter } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AccountComponent } from './account/account.component';
import { CustomDateAdapter } from './custom-date.adapter';
import { ResendDocumentComponent } from './documents/resenddocumentprocess/resend-document.component';
import { NewpasswordComponent } from './guest/newpassword/newpassword.component';
import { ResetpasswordComponent } from './guest/resetpassword/resetpassword.component';
import { ErrormessagePipe } from './pipe/errormessage.pipe';
import { ResenddocumentprocessComponent } from './processes/resenddocumentprocess/resenddocumentprocess.component';
import { PresentationComponent } from './public/presentation/presentation.component';
import { ContextMenuComponent } from './templates/context-menu/context-menu.component';
import { OwnDocumentComponent } from './templates/own-document/own-document.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SignersComponent,
    TemplatesComponent,
    ViewtemplateComponent,
    SigntemplateComponent,
    EditsignerComponent,
    NewsignerComponent,
    ViewSignerComponent,
    DocumentsComponent,
    ResendDocumentComponent,
    DocumentDetailsComponent,
    GuestLoginComponent,
    GuestDocumentsComponent,
    GuestSetSignerComponent,
    HeaderComponent,
    SafeHtmlPipe,
    ProcessComponent,
    ViewprocessComponent,
    ProcessesConfigComponent,
    SigndocumentprocessComponent,
    ResenddocumentprocessComponent,
    StatsComponent,
    GuestSetdownComponent,
    GuestSetupComponent,
    ViewProcessDocumentComponent,
    StopPropagationDirective,
    SpinnerComponent,
    SharedDocumentDetailsComponent,
    NewpasswordComponent,
    ResetpasswordComponent,
    PresentationComponent,
    AccountComponent,
    OwnDocumentComponent,
    ErrormessagePipe,
    ContextMenuComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatCardModule,
    MatPaginatorModule,
    MatTableModule,
    MatSortModule,
    MatButtonModule,
    MatAutocompleteModule,
    MatSnackBarModule,
    MatToolbarModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    DragDropModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTooltipModule,
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
    { provide: DateAdapter, useClass: CustomDateAdapter },
    MatDatepickerModule,
    MatNativeDateModule,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
